export default __webpack_public_path__ + "static/media/ET Bluegrass Raffle.2265aeee.mp4";